import React from "react";
import quoteStreamService from "../lib/Firebase/QuoteStreamService";
import withTranslations from "./withTranslations";

const defaultIntervalTypeId = 7;

export default function withQuoteData(
  wait = false,
  stockIdExtractor = () => null
) {
  function getStockIdFromProps(props) {
    const { stock, stock_id: providedStockId, resultMetaData } = props;

    const { id: stockId, stock_id } = stock || {};
    const { stock_id: stockIdFromUniversalTableResult } = resultMetaData || {};
    const stockIdFromExtractor = stockIdExtractor(props);

    return (
      stockIdFromExtractor ||
      stockId ||
      stock_id ||
      providedStockId ||
      stockIdFromUniversalTableResult ||
      (typeof stock !== "undefined" && typeof stock === "number" ? stock : null)
    );
  }

  function getIntervalTypeIdFromProps(props) {
    return props.intervalTypeId || defaultIntervalTypeId;
  }

  function getPathFromProps(props) {
    const stockId = getStockIdFromProps(props);
    const intervalTypeId = getIntervalTypeIdFromProps(props);
    return stockId && intervalTypeId
      ? `quotes/${stockId}/${intervalTypeId}`
      : null;
  }

  return function(WrappedComponent) {
    @withTranslations
    class WithQuoteData extends React.Component {
      _unsubscribe = null;
      _subscribedPath = null;

      state = {
        quoteData: null,
        emptyQuoteData: true
      };

      subscribeToQuotes() {
        const newPath = getPathFromProps(this.props);

        if (!newPath) {
          return;
        }

        if (newPath === this._subscribedPath && this._unsubscribe) {
          return;
        }

        if (this._unsubscribe) {
          this._unsubscribe();
          this._unsubscribe = null;
        }

        const stockId = getStockIdFromProps(this.props);
        const intervalTypeId = getIntervalTypeIdFromProps(this.props);

        this._subscribedPath = newPath;
        this._unsubscribe = quoteStreamService.subscribe({
          stockId,
          intervalTypeId,
          onQuote: quoteData => {
            this.setState({
              quoteData
            });
          }
        });
      }

      componentDidMount() {
        this.subscribeToQuotes();
      }

      componentDidUpdate(prevProps) {
        const prevPath = getPathFromProps(prevProps);
        const nextPath = getPathFromProps(this.props);

        if (prevPath !== nextPath || !this._unsubscribe) {
          this.subscribeToQuotes();
        }
      }

      componentWillUnmount() {
        if (this._unsubscribe) {
          this._unsubscribe();
          this._unsubscribe = null;
        }
        this._subscribedPath = null;
      }

      static defaultProps = {
        intervalTypeId: defaultIntervalTypeId
      };

      render() {
        const { quoteData } = this.state;

        const emptyQuoteData = quoteData === null;

        if (wait && !quoteData) {
          return null;
        }

        return (
          <WrappedComponent
            {...this.props}
            quoteData={quoteData}
            emptyQuoteData={emptyQuoteData}
          />
        );
      }
    }

    return WithQuoteData;
  };
}
